/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'mi-progreso',
        title: 'Progreso Académico',
        type: 'basic',
        icon: 'book',
        link: '/mi-progreso/programas',
    },
    {
        id: 'expediente-digital',
        title: 'Expediente Digital',
        type: 'basic',
        icon: 'folder_special',
        link: '/expediente-digital/programas',
    },
    {
        id: 'historial-pagos',
        title: 'Historial de Pagos',
        type: 'basic',
        icon: 'payment',
        link: '/historial-pagos/programas',
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'mi-progreso',
        title: 'Progreso Académico',
        type: 'basic',
        icon: 'book',
        link: '/mi-progreso/programas',
    },
    {
        id: 'expediente-digital',
        title: 'Expediente Digital',
        type: 'basic',
        icon: 'folder_special',
        link: '/expediente-digital/programas',
    },
    {
        id: 'historial-pagos',
        title: 'Historial de Pagos',
        type: 'basic',
        icon: 'payment',
        link: '/historial-pagos/programas',
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'mi-progreso',
        title: 'Progreso Académico',
        type: 'basic',
        icon: 'book',
        link: '/mi-progreso/programas',
    },
    {
        id: 'expediente-digital',
        title: 'Expediente Digital',
        type: 'basic',
        icon: 'folder_special',
        link: '/expediente-digital/programas',
    },
    {
        id: 'historial-pagos',
        title: 'Historial de Pagos',
        type: 'basic',
        icon: 'payment',
        link: '/historial-pagos/programas',
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'mi-progreso',
        title: 'Progreso Académico',
        type: 'basic',
        icon: 'book',
        link: '/mi-progreso/programas',
    },
    {
        id: 'expediente-digital',
        title: 'Expediente Digital',
        type: 'basic',
        icon: 'folder_special',
        link: '/expediente-digital/programas',
    },
    {
        id: 'historial-pagos',
        title: 'Historial de Pagos',
        type: 'basic',
        icon: 'payment',
        link: '/historial-pagos/programas',
    },
];
